export default {
  shopTitle: 'Platform Announcement',
  allInfo: 'All',
  haveRead: 'Read',
  unread: 'UnRead',
  ShopNews: '店铺消息',
  infoTitle: '消息标题',
  infoContent: '消息内容',
  publishDate: 'Announce Time',
  messageId: 'MessageId',
  title: 'Title',
  content: 'Content',
  delete: 'Delete',
  selectDate: 'Select date'
}
